<template>
    <transition-group @enter="enter" appear>
        <slot></slot>
    </transition-group>
</template>

<script>
    import { gsap } from "gsap";

    export default {
        name: "GroupTransition",
        methods: {
            enter(el, done) {
                gsap.fromTo(el,
                {
                    opacity: 0,
                    scale: .95,
                    transformOrigin: "top",
                },
                {
                    opacity: 1,
                    scale: 1,
                    duration: 0.3,
                    ease: "power2.inOut",
                    onComplete: done,
                });
            },
        }
    }
</script>